import type { LegalDocument } from '../types';

/** Источник: «Пользовательское соглашение.docx». Файл сгенерирован — правки вносите в документ. */
export const doc: LegalDocument = {
  title: 'Пользовательское соглашение Aura',
  blocks: [
    {
      kind: 'heading',
      text: 'Раздел 1. Стороны и общие положения',
    },
    {
      kind: 'para',
      number: '1.1.',
      text: 'Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между ООО «Фалкон», зарегистрированным в соответствии с законодательством Республики Абхазия, ОГРН 108РА000782, ИНН 11008213, юридический адрес: проспект Мира 16, г. Сухум, Республика Абхазия (далее — Компания), и лицом, прошедшим регистрацию и использующим мобильное приложение Aura (далее — Пользователь).',
    },
    {
      kind: 'para',
      number: '1.2.',
      text: 'Настоящее Соглашение является публичной офертой. Регистрация учетной записи, установка или фактическое использование Приложения означают полное и безоговорочное согласие Пользователя с условиями Соглашения и принятие обязательств по их исполнению.',
    },
    {
      kind: 'para',
      number: '1.3.',
      text: 'Приложение Aura представляет собой социальную сеть, предназначенную для общения, знакомств, обмена контентом, участия в мероприятиях, взаимодействия со специалистами и партнерами, а также использования внутренней виртуальной валюты Kelvin.',
    },
    {
      kind: 'para',
      number: '1.4.',
      text: 'Контактные данные для обращений Пользователей: Электронная почта: support@aura-vibe.site. При обращении по поводу технических ошибок рекомендуется указывать тип устройства, версию операционной системы, описание проблемы и, при необходимости, скриншоты.',
    },
    {
      kind: 'para',
      number: '1.5.',
      text: 'Компания оставляет за собой право изменять условия Соглашения, интерфейс, функциональность и политику работы Приложения. Обновленная версия Соглашения вступает в силу с момента ее публикации в Приложении или на официальном сайте https://aura-vibe.site. Компания может вносить изменения в Соглашение путем уведомления одним или несколькими из следующих способов:',
    },
    {
      kind: 'bullet',
      text: 'через Приложение во время или после входа в учетную запись, в том числе путем отправки всплывающего уведомления в Приложении;',
    },
    {
      kind: 'bullet',
      text: 'через Приложение в чате с технической поддержкой;',
    },
    {
      kind: 'bullet',
      text: 'путем отправки push-уведомления, сообщения по электронной почте или размещения заметного объявления в Приложении не менее чем за 10 (десять) календарных дней до вступления изменений в силу. Дальнейшее использование Приложения после вступления изменений в силу означает полное и безоговорочное согласие Пользователя с новой версией Соглашения.',
    },
    {
      kind: 'para',
      number: '1.6.',
      text: 'К отношениям, возникающим из настоящего Соглашения, применяются законодательство Республики Абхазия и законодательные акты Республики Абхазия, если иное прямо не предусмотрено настоящим Соглашением.',
    },
    {
      kind: 'heading',
      text: 'Раздел 2. Регистрация и учетная запись Пользователя',
    },
    {
      kind: 'para',
      number: '2.1.',
      text: 'Регистрация в Приложении доступна Пользователям, достигшим возраста 16 лет. Функции, связанные с разделом «Знакомства», размещением специалистов на карте и взаимодействием с партнерами, доступны только Пользователям, достигшим возраста 18 лет.',
    },
    {
      kind: 'para',
      number: '2.2.',
      text: 'Для регистрации в Приложении Пользователь обязан предоставить следующие сведения: имя, фамилию, дату рождения, номер телефона или адрес электронной почты, фотографию профиля и гражданство. Пользователь обязуется предоставлять точную, актуальную и полную информацию.',
    },
    {
      kind: 'para',
      number: '2.3.',
      text: 'В Приложении может быть реализована процедура проверки личности Пользователя. Подтверждение личности требуется для доступа к определенным функциям, включая:',
    },
    {
      kind: 'bullet',
      text: 'использование раздела «Любовь» (знакомства);',
    },
    {
      kind: 'bullet',
      text: 'создание событий на интерактивной карте;',
    },
    {
      kind: 'bullet',
      text: 'использование всех функций, связанных с виртуальной валютой Kelvin (отправка, получение, оплата партнерам);',
    },
    {
      kind: 'bullet',
      text: 'создание профессионального профиля «СПЕЦИАЛИСТ» и добавление бизнеса на карту в качестве партнера. Верификация осуществляется в целях безопасности и предотвращения злоупотреблений.',
    },
    {
      kind: 'para',
      number: '2.4.',
      text: 'Один Пользователь может иметь только одну учетную запись. Создание нескольких учетных записей, использование чужих данных, регистрация от имени других лиц и обход процедур проверки личности не допускаются. В случае нарушения указанных требований Компания вправе приостановить или заблокировать учетную запись Пользователя без предварительного уведомления.',
    },
    {
      kind: 'para',
      number: '2.5.',
      text: 'Имя пользователя (логин) должно быть написано латинскими буквами. Запрещается использование логина или аватара, если они:',
    },
    {
      kind: 'bullet',
      text: 'содержат нецензурную лексику, оскорбления или унижение чести и достоинства других лиц, разжигают межнациональную рознь;',
    },
    {
      kind: 'bullet',
      text: 'пропагандируют насилие, экстремизм, терроризм или дискриминацию по признаку расы, национальности, религии или иным основаниям;',
    },
    {
      kind: 'bullet',
      text: 'содержат упоминания наркотиков, азартных игр или порнографии;',
    },
    {
      kind: 'bullet',
      text: 'содержат рекламу или коммерческие призывы, ссылки на сторонние веб-сайты и ресурсы;',
    },
    {
      kind: 'bullet',
      text: 'включают персональные данные третьих лиц без их согласия;',
    },
    {
      kind: 'bullet',
      text: 'нарушают права интеллектуальной собственности третьих лиц (включая использование чужих логотипов, товарных знаков, брендов);',
    },
    {
      kind: 'bullet',
      text: 'содержат порнографические материалы, сцены насилия или жестокости;',
    },
    {
      kind: 'bullet',
      text: 'создают ложное впечатление о принадлежности Пользователя к Компании или другим лицам.',
    },
    {
      kind: 'para',
      number: '2.6.',
      text: 'Компания вправе в любое время запросить подтверждение данных, предоставленных при регистрации, а также временно ограничить доступ к определенным функциям Приложения в случае несоответствия предоставленной информации действительности.',
    },
    {
      kind: 'heading',
      text: 'Раздел 3. Контент и интеллектуальная собственность',
    },
    {
      kind: 'para',
      number: '3.1.',
      text: 'Пользователь может размещать контент в Приложении, включая текстовые сообщения, комментарии, публикации, фотографии, видео, аудиозаписи (в том числе голосовые сообщения), а также данные геолокации, связанные с публикациями или созданием событий на интерактивной карте. Размещение ссылок на сторонние ресурсы запрещено.',
    },
    {
      kind: 'para',
      number: '3.2.',
      text: 'Пользователь вправе размещать в Приложении только тот контент, на который у него имеются все необходимые права или лицензии. Пользователь несет полную ответственность за любое нарушение прав третьих лиц, включая авторские права, смежные права, товарные знаки, изображения и иные охраняемые объекты. Компания не несет ответственности за размещение Пользователем контента, права на который принадлежат третьим лицам.',
    },
    {
      kind: 'para',
      number: '3.3.',
      text: 'Размещая собственный контент в Приложении, Пользователь предоставляет Компании безвозмездную, бессрочную, неисключительную лицензию, действующую на территории всего мира, на использование этого контента следующими',
    },
    {
      kind: 'para',
      text: 'способами:',
    },
    {
      kind: 'bullet',
      text: 'воспроизведение (запись, хранение, резервное копирование на серверах Компании);',
    },
    {
      kind: 'bullet',
      text: 'обработка, включая модерацию с использованием искусственного интеллекта, изменение размера, формата и качества для корректного отображения;',
    },
    {
      kind: 'bullet',
      text: 'публичный показ и распространение в ленте, профиле и других разделах Приложения;',
    },
    {
      kind: 'bullet',
      text: 'доведение до сведения других Пользователей в соответствии с функционалом Приложения (включая чаты и рекомендации). Компания не приобретает прав на коммерческое использование контента Пользователя за пределами функционала Приложения, за исключением распространения такого контента (или его части) в обезличенной форме в информационных, рекламных и маркетинговых целях, связанных с продвижением Приложения Aura, без выплаты Пользователю дополнительного вознаграждения.',
    },
    {
      kind: 'para',
      number: '3.4.',
      text: 'Все права на элементы Приложения, включая тексты, изображения, видеоматериалы, дизайн, логотипы, исходный код, интерфейс и иные результаты интеллектуальной деятельности, принадлежат Компании и охраняются в соответствии с законодательством Республики Абхазия и международными соглашениями. Копирование, воспроизведение, распространение, декомпиляция, модификация и иное использование элементов Приложения без письменного разрешения Компании запрещены.',
    },
    {
      kind: 'para',
      number: '3.5.',
      text: 'Пользователь вправе подать жалобу на контент, который, по его мнению, нарушает условия Соглашения, законодательство или права третьих лиц, через Приложение. Компания рассматривает такие жалобы и при необходимости принимает меры от удаления контента до блокировки учетной записи Пользователя. Для удобства Пользователей в интерфейсе предусмотрены стандартные категории жалоб.',
    },
    {
      kind: 'heading',
      text: 'Раздел 4. Правила поведения и',
    },
    {
      kind: 'heading',
      text: 'модерация',
    },
    {
      kind: 'para',
      number: '4.1.',
      text: 'В Приложении строго запрещены размещение контента и совершение действий, перечисленных ниже. Нарушение настоящего пункта влечет удаление контента, ограничение доступа или блокировку учетной записи.',
    },
    {
      kind: 'para',
      text: 'А. Контент, нарушающий законодательство и угрожающий безопасности:',
    },
    {
      kind: 'para',
      number: '1.',
      text: 'Разжигание ненависти, пропаганда или оправдание войны, межнациональной, расовой, религиозной или социальной розни, ксенофобии, дискриминации.',
    },
    {
      kind: 'para',
      number: '2.',
      text: 'Пропаганда терроризма, экстремизма, демонстрация символики запрещенных организаций, призывы к насилию.',
    },
    {
      kind: 'para',
      number: '3.',
      text: 'Публикация материалов, содержащих сцены насилия, жестокого обращения с людьми или животными, призывы к причинению вреда себе или другим.',
    },
    {
      kind: 'para',
      number: '4.',
      text: 'Порнография, материалы сексуального характера, предложения сексуальных услуг.',
    },
    {
      kind: 'para',
      number: '5.',
      text: 'Пропаганда, описание способов изготовления или употребления наркотических и психотропных веществ.',
    },
    {
      kind: 'para',
      number: '6.',
      text: 'Информация о нелегальных азартных играх и букмекерских конторах.',
    },
    {
      kind: 'para',
      number: '7.',
      text: 'Публикация персональных данных третьих лиц без их согласия.',
    },
    {
      kind: 'para',
      text: 'Б. Действия, нарушающие права и комфорт Пользователей:',
    },
    {
      kind: 'para',
      number: '8.',
      text: 'Оскорбления, угрозы, шантаж, травля, домогательства и преследование.',
    },
    {
      kind: 'para',
      number: '9.',
      text: 'Мошенничество, фишинг, создание поддельных аккаунтов, обман при транзакциях с Kelvin.',
    },
    {
      kind: 'para',
      number: '10.',
      text: 'Спам и несанкционированная реклама товаров, услуг или сторонних ресурсов.',
    },
    {
      kind: 'para',
      number: '11.',
      text: 'Вымогательство денег, Kelvin или иного имущества под угрозой разглашения информации.',
    },
    {
      kind: 'para',
      text: 'В. Нарушения, связанные с функционированием платформы:',
    },
    {
      kind: 'para',
      number: '12.',
      text: 'Размещение контента, нарушающего авторские или иные права третьих лиц.',
    },
    {
      kind: 'para',
      number: '13.',
      text: 'Распространение вирусов, троянов, попытки взлома, DDoS- атаки, вмешательство в работу Приложения.',
    },
    {
      kind: 'para',
      number: '14.',
      text: 'Выдача себя за другое лицо, организацию или бренд без надлежащих оснований.',
    },
    {
      kind: 'para',
      number: '15.',
      text: 'Использование ошибок или стороннего программного обеспечения для обхода ограничений, искусственного повышения рейтинга или получения преимуществ.',
    },
    {
      kind: 'para',
      text: 'Г. Контент, противоречащий ценностям платформы:',
    },
    {
      kind: 'para',
      number: '16.',
      text: 'Пропаганда девиантного поведения, неуважение к культурным и семейным ценностям народов Абхазии и других стран.',
    },
    {
      kind: 'para',
      number: '17.',
      text: 'Распространение сепаратистских и экстремистских идей.',
    },
    {
      kind: 'para',
      number: '4.2.',
      text: 'К нарушителям могут применяться следующие меры:',
    },
    {
      kind: 'bullet',
      text: 'предупреждение;',
    },
    {
      kind: 'bullet',
      text: 'временная приостановка учетной записи;',
    },
    {
      kind: 'bullet',
      text: 'полная блокировка и удаление учетной записи;',
    },
    {
      kind: 'bullet',
      text: 'удаление или ограничение доступа к контенту. Выбор меры зависит от характера и тяжести нарушения.',
    },
    {
      kind: 'para',
      number: '4.3.',
      text: 'Модерация контента осуществляется преимущественно автоматизированными средствами с использованием алгоритмов и технологий искусственного интеллекта. Компания вправе применять ручную модерацию в спорных случаях или по запросам Пользователей.',
    },
    {
      kind: 'para',
      number: '4.4.',
      text: 'В дополнение к правилам, установленным в Разделе 4, Пользователю строго запрещается:',
    },
    {
      kind: 'para',
      number: '4.4.1.',
      text: 'a) Вмешиваться в надлежащее функционирование Приложения, нарушать работу или перегружать серверы и сети, обеспечивающие его работу. Это включает, среди прочего, попытки несанкционированного доступа к Приложению, чужим учетным записям, компьютерным системам или сетям, а также организацию или участие в любых видах кибератак. b) Использовать или способствовать разработке и распространению стороннего программного обеспечения (включая эксплойты, ботов, читы, скрипты) для модификации, вмешательства или получения несанкционированных преимуществ при использовании Приложения. c) Осуществлять обратное проектирование, декомпиляцию, дизассемблирование или иным образом пытаться извлечь исходный код Приложения или лежащую в его основе интеллектуальную собственность, за исключением случаев, прямо разрешенных законом. d) Использовать любые технологии для сокрытия своего местоположения или обхода географических и иных ограничений доступа к функционалу Приложения. e) Использовать или внедрять любые автоматизированные системы (скрипты, «пауки», «парсеры») для сбора, извлечения или передачи данных из Приложения без предварительного письменного разрешения Компании.',
    },
    {
      kind: 'para',
      number: '4.4.2.',
      text: 'a) Копировать, изменять, распространять или иным образом использовать контент, товарные знаки и иную интеллектуальную собственность, принадлежащую Компании, за пределами функционала, предоставляемого Приложением. b) Публично распространять любую информацию, полученную в ходе конфиденциального общения со службой поддержки Компании. c) Публично распространять информацию о методах и средствах нарушения настоящего Соглашения или Политики конфиденциальности, а также прямо или косвенно побуждать к их нарушению.',
    },
    {
      kind: 'heading',
      text: 'Раздел 5. Внутриприложения покупки и виртуальная валюта Kelvin',
    },
    {
      kind: 'para',
      number: '5.1.',
      text: 'В Приложении доступны платные функции и услуги, включая:',
    },
    {
      kind: 'bullet',
      text: 'премиум-подписка;',
    },
    {
      kind: 'bullet',
      text: 'VIP-подписка;',
    },
    {
      kind: 'bullet',
      text: 'подписка на раздел «Знакомства»;',
    },
    {
      kind: 'bullet',
      text: 'покупка виртуальных подарков;',
    },
    {
      kind: 'bullet',
      text: 'покупка внутренней валюты Kelvin. Информация, содержащаяся в интерфейсе Приложения, включая описание платных функций и услуг, имеет юридическую силу и является неотъемлемой частью Пользовательского соглашения. Пользователь обязуется самостоятельно ознакомиться с условиями конкретной услуги, отображаемыми в интерфейсе Приложения, перед приобретением платных функций. Факт приобретения Пользователем платных функций через интерфейс Приложения означает его согласие с соответствующими условиями, которые становятся частью обязательств между Пользователем и Компанией.',
    },
    {
      kind: 'para',
      number: '5.2.',
      text: 'Все платежи, связанные с приобретением платных функций и Kelvin, осуществляются через платежные системы третьих лиц:',
    },
    {
      kind: 'bullet',
      text: 'для устройств iOS — через App Store с использованием платежных методов, привязанных к учетной записи Apple ID (включая Apple Pay, банковские карты и иные методы, поддерживаемые Apple);',
    },
    {
      kind: 'bullet',
      text: 'для устройств Android — через Google Play с использованием платежных методов, привязанных к учетной записи Google Play;',
    },
    {
      kind: 'bullet',
      text: 'для пользователей из Российской Федерации — через Юкассу (YooKassa).',
    },
    {
      kind: 'para',
      number: '5.3.',
      text: 'Все покупки в Приложении, включая подписки и приобретение Kelvin, являются окончательными и не подлежат возврату, за исключением следующих случаев:',
    },
    {
      kind: 'bullet',
      text: 'технический сбой, делающий невозможным использование платной функции;',
    },
    {
      kind: 'bullet',
      text: 'существенное несоответствие платной услуги описанию, представленному в Приложении. При наступлении указанных обстоятельств Пользователь вправе обратиться:',
    },
    {
      kind: 'bullet',
      text: 'за покупками, совершенными через App Store или Google Play,',
    },
    {
      kind: 'bullet',
      text: 'в службу поддержки соответствующего маркетплейса;',
    },
    {
      kind: 'bullet',
      text: 'за покупками, совершенными через иные платежные системы,',
    },
    {
      kind: 'bullet',
      text: 'в службу поддержки Компании по адресу support@aura-vibe.site в течение 24 часов с момента оплаты с указанием платежных реквизитов и обоснования возврата.',
    },
    {
      kind: 'para',
      number: '5.4.',
      text: 'Виртуальная валюта Kelvin не имеет денежного эквивалента, не может быть обменяна на деньги, товары или иное имущество и не подлежит возврату после приобретения. В случае удаления или блокировки учетной записи все неиспользованные Kelvin аннулируются без компенсации.',
    },
    {
      kind: 'para',
      number: '5.5.',
      text: 'Подписки на платные функции автоматически продлеваются, если Пользователь не отключил автопродление в настройках соответствующего магазина приложений или в интерфейсе Приложения. Отмена продления не влияет на срок действия уже оплаченного периода.',
    },
    {
      kind: 'para',
      number: '5.6.',
      text: 'Компания не несет ответственности за комиссии платежных систем, технические сбои, отказ в проведении транзакции или возможные расхождения между курсом обмена на момент оплаты и стоимостью, отображаемой в Приложении.',
    },
    {
      kind: 'para',
      number: '5.7.',
      text: 'Пользователь признает и соглашается с тем, что Kelvin представляет собой внутриигровой служебный токен, который может использоваться исключительно в рамках функционала Приложения Aura для доступа к дополнительным услугам и функциям. Kelvin не является криптовалютой, средством платежа, ценной бумагой или финансовым активом. Он не имеет денежной стоимости за пределами Приложения и не может быть обменян на деньги или иные ценности, за исключением случаев, прямо предусмотренных функционалом Приложения.',
    },
    {
      kind: 'heading',
      text: 'Раздел 6. Персональные данные и конфиденциальность',
    },
    {
      kind: 'para',
      text: 'Обработка и защита персональных данных Пользователей осуществляется в соответствии с Политикой конфиденциальности, размещенной в Приложении и на сайте Компании по адресу https://aura-vibe.site/privacy_policy.',
    },
    {
      kind: 'para',
      text: 'Если Пользователь является гражданином Российской Федерации и стран СНГ, обработка его персональных данных осуществляется в соответствии с Политикой конфиденциальности, размещенной по адресу https://aura-vibe.site/privacy_policy.',
    },
    {
      kind: 'heading',
      text: 'Раздел 7. Ответственность и порядок разрешения споров',
    },
    {
      kind: 'para',
      number: '7.1.',
      text: 'Компания предоставляет Пользователю техническую возможность размещать контент, общаться и взаимодействовать с другими Пользователями, но не является автором, инициатором или издателем размещаемых материалов. Компания не осуществляет предварительную проверку всего контента, размещаемого Пользователями, и не несет ответственности за его содержание.',
    },
    {
      kind: 'para',
      number: '7.2.',
      text: 'Пользователь несет полную ответственность за:',
    },
    {
      kind: 'bullet',
      text: 'достоверность и законность размещаемого контента;',
    },
    {
      kind: 'bullet',
      text: 'соблюдение прав и законных интересов третьих лиц;',
    },
    {
      kind: 'bullet',
      text: 'последствия любых действий, совершенных с использованием Приложения;',
    },
    {
      kind: 'bullet',
      text: 'убытки, причиненные другим Пользователям, Компании или третьим лицам в результате использования Приложения.',
    },
    {
      kind: 'para',
      number: '7.3.',
      text: 'Компания не несет ответственности за:',
    },
    {
      kind: 'bullet',
      text: 'содержание и последствия использования пользовательского контента;',
    },
    {
      kind: 'bullet',
      text: 'сделки, соглашения или иные отношения между Пользователями, возникающие за пределами функционала Приложения;',
    },
    {
      kind: 'bullet',
      text: 'убытки, причиненные разглашением учетных данных Пользователя третьим лицам;',
    },
    {
      kind: 'bullet',
      text: 'неполадки в работе платежных систем, магазинов приложений (Apple, Google и т.д.);',
    },
    {
      kind: 'bullet',
      text: 'временную недоступность Приложения, вызванную техническими работами, обновлениями или обстоятельствами непреодолимой силы.',
    },
    {
      kind: 'para',
      number: '7.4.',
      text: 'Компания не гарантирует бесперебойную или безошибочную работу Приложения, соответствие услуг ожиданиям Пользователя, а также точность или полноту информации, размещенной другими Пользователями.',
    },
    {
      kind: 'para',
      number: '7.5.',
      text: 'Компания не несет ответственности за косвенные, случайные, штрафные убытки или упущенную выгоду, включая потерю данных, прибыли, репутации, перерывы в деятельности, даже если она была предупреждена о возможности таких убытков. Размер возможных убытков, подлежащих возмещению, ограничивается суммой, фактически уплаченной Пользователем за последние 30 дней использования Приложения.',
    },
    {
      kind: 'para',
      number: '7.6.',
      text: 'Все споры и разногласия, возникающие между Пользователем и Компанией, разрешаются в досудебном порядке. Пользователь обязан направить письменную претензию на адрес support@aura-vibe.site. Компания рассматривает претензию в течение 30 календарных дней с даты получения.',
    },
    {
      kind: 'para',
      number: '7.7.',
      text: 'Если спор не урегулирован во внесудебном порядке, он рассматривается в судах и органах Республики Абхазия в соответствии с законодательством Республики Абхазия.',
    },
    {
      kind: 'para',
      number: '7.8.',
      text: 'Отношения между Компанией и Пользователем регулируются законодательством Республики Абхазия, если иное не предусмотрено международными договорами или императивными нормами страны проживания Пользователя.',
    },
    {
      kind: 'para',
      number: '7.9.',
      text: 'Пользователь признает и соглашается с тем, что он несет единоличную ответственность за любое взаимодействие, общение и построение отношений с другими пользователями Приложения. Компания не проверяет биографические данные пользователей, не контролирует и не может гарантировать безопасность и законность их действий. В связи с этим Пользователям настоятельно рекомендуется соблюдать осторожность и воздерживаться от разглашения конфиденциальной личной и финансовой информации третьим лицам во избежание ее неправомерного использования.',
    },
    {
      kind: 'para',
      number: '7.10.',
      text: 'Пользователь настоящим освобождает Компанию, ее руководство, сотрудников и аффилированных лиц от любых претензий, требований и исков, связанных с: a) Противоправными действиями третьих лиц, включая, но не ограничиваясь: мошенничеством, домогательствами, клеветой, распространением ложной информации. b) Любыми финансовыми или имущественными потерями, понесенными Пользователем в результате взаимодействия с другими пользователями или третьими лицами, если такие потери не возникли по прямой вине Компании. c) Техническими сбоями, ошибками в транзакциях или временным несоответствием функционала Приложения ожиданиям Пользователя. d) Последствиями несанкционированного доступа третьих лиц к учетной записи Пользователя, если такой доступ стал возможен в результате действий или бездействия самого Пользователя. Данный перечень не является исчерпывающим. Настоящий отказ от претензий является всеобъемлющим и имеет обязательную юридическую силу.',
    },
    {
      kind: 'para',
      number: '7.11.',
      text: 'Компания оставляет за собой право, но не принимает на себя обязательство осуществлять мониторинг контента, загружаемого Пользователями. Компания может по своему усмотрению или на основании обоснованного запроса третьего лица или уполномоченного органа удалять любые материалы, которые, по мнению Компании, нарушают настоящее Соглашение или применимое законодательство Республики Абхазия.',
    },
    {
      kind: 'heading',
      text: 'Раздел 8. Заключительные положения',
    },
    {
      kind: 'para',
      number: '8.1.',
      text: 'Настоящее Соглашение вступает в силу с момента его принятия Пользователем и действует до удаления учетной записи Пользователя или прекращения доступа Пользователя к Приложению.',
    },
    {
      kind: 'para',
      number: '8.2.',
      text: 'Пользователь вправе в любое время прекратить использование Приложения и удалить свою учетную запись. Удаление учетной записи прекращает действие настоящего Соглашения в отношении данного Пользователя, за исключением обязательств, которые по своей природе остаются в силе после прекращения (ответственность за размещенный контент или нарушение прав третьих лиц).',
    },
    {
      kind: 'para',
      number: '8.3.',
      text: 'Компания вправе вносить изменения в Соглашение и обновлять функционал Приложения. Новая версия Соглашения вступает в силу с момента ее публикации на официальном сайте https://aura-vibe.site или в интерфейсе Приложения. Пользователь обязан самостоятельно отслеживать актуальную версию Соглашения. Продолжение использования Приложения после внесения изменений означает принятие новой версии.',
    },
    {
      kind: 'para',
      number: '8.4.',
      text: 'Все уведомления, запросы и обращения, связанные с исполнением настоящего Соглашения, направляются на адрес электронной почты support@aura-vibe.site, если иное не предусмотрено интерфейсом Приложения.',
    },
    {
      kind: 'para',
      number: '8.5.',
      text: 'Если какое-либо положение настоящего Соглашения будет признано недействительным или не подлежащим принудительному исполнению, это не влечет недействительность остальных положений. Такие положения заменяются положениями, сходными по смыслу и цели и максимально близкими к изначальному намерению сторон.',
    },
    {
      kind: 'heading',
      text: '9. Отказ от гарантий',
    },
    {
      kind: 'para',
      number: '9.1.',
      text: 'Приложение и все связанные с ним услуги предоставляются на условиях «как есть» (as is) и «по мере доступности» (as available). Компания прямо отказывается от всех гарантий, явно выраженных или подразумеваемых, включая, но не ограничиваясь, гарантиями товарной пригодности, соответствия для конкретной цели и ненарушения прав интеллектуальной собственности. Компания не гарантирует, что Приложение будет работать бесперебойно, без ошибок, будет безопасным или доступным в любое время.',
    },
    {
      kind: 'para',
      number: '9.2.',
      text: 'Пользователь признает и принимает риски того, что любые данные, хранящиеся или передаваемые с использованием Приложения, могут быть утрачены, повреждены или стать временно недоступными. Компания не несет ответственности за такие инциденты, возникшие, среди прочего, в результате: сбоев программного обеспечения; перебоев в работе сети Интернет или сторонних сервисов; обстоятельств непреодолимой силы, включая DDoS-атаки; плановых или аварийных технических работ; а также любых иных причин, находящихся вне разумного контроля Компании.',
    },
    {
      kind: 'para',
      number: '9.3.',
      text: 'Пользователь несет единоличную ответственность за создание и хранение резервных копий любой важной для него информации, размещенной или передаваемой через Приложение.',
    },
  ],
};
